import { render, staticRenderFns } from "./PartCustomerPriceDetails.vue?vue&type=template&id=1e6bbf60"
import script from "./PartCustomerPriceDetails.vue?vue&type=script&lang=js"
export * from "./PartCustomerPriceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports